import { css } from '@linaria/atomic';
import { TableInstance } from 'react-table';
import { theme } from '@frontend/theme';
import { Text } from '../../';
import { TableData } from '../table-data-type';
import { TableBulkActions } from '../table-types';
import { BulkActions } from './bulk-actions.component';
import { SelectAllRows } from './select-all-rows.component';

const bulkRowsWrapperStyle = css`
  display: flex;
  align-items: center;
  margin-right: auto;
  flex-shrink: 1;
  padding-left: ${theme.spacing(1)};
`;

const bulkRowsTextMobileStyle = css`
  margin: 0;
  margin-left: ${theme.spacing(1)};
`;

const bulkRowsTextDesktopStyle = css`
  margin: 0;
  margin-left: ${theme.spacing(2)};
`;

type BulkRowsUtilitiesProps<T extends TableData> = {
  tableInstance: TableInstance<T>;
  bulkActions?: TableBulkActions<T>[];
};

export const BulkRowsUtilities = <T extends TableData>({ tableInstance, bulkActions }: BulkRowsUtilitiesProps<T>) => {
  const { selectedFlatRows, flatRows, isMobile, rowSelectionConfig } = tableInstance;

  const hasSelectAllOverride = !!rowSelectionConfig?.selectAllLabel;

  const nonDisabledRows = !rowSelectionConfig?.isRowDisabled
    ? [...flatRows]
    : flatRows.filter((row) =>
        typeof rowSelectionConfig?.isRowDisabled === 'boolean'
          ? !rowSelectionConfig?.isRowDisabled
          : !rowSelectionConfig?.isRowDisabled?.(row.original, row)
      );

  return (
    <div className={bulkRowsWrapperStyle}>
      <SelectAllRows tableInstance={tableInstance} nonDisabledRows={nonDisabledRows} />
      {!hasSelectAllOverride && !!selectedFlatRows.length && (
        <>
          {isMobile ? (
            <Text className={bulkRowsTextMobileStyle} size='medium'>
              {selectedFlatRows.length}/{nonDisabledRows.length}
            </Text>
          ) : (
            <Text className={bulkRowsTextDesktopStyle} size='medium'>
              Selected {selectedFlatRows.length} of {flatRows.length}
            </Text>
          )}
          <BulkActions tableInstance={tableInstance} bulkActions={bulkActions} selectedRows={selectedFlatRows} />
        </>
      )}
    </div>
  );
};
